"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolvablePromise = void 0;
var noop = function () { };
/**
 * Create a promise which has resolve() and reject() methods
 *
 * Useful when you want to avoid a race condition by constructing a promise,
 * storing it somewhere, and _then_ starting the actual work.
 */
function resolvablePromise() {
    var resolve = noop;
    var reject = noop;
    var promise = new Promise(function (res, rej) {
        resolve = res;
        reject = rej;
    });
    return Object.assign(promise, { resolve: resolve, reject: reject });
}
exports.resolvablePromise = resolvablePromise;
//# sourceMappingURL=resolvable-promise.js.map